import javascript from "../../../assets/img/programming/javascript.webp";
import typescript from "../../../assets/img/programming/typescript.webp";
import java from "../../../assets/img/programming/java.webp";
import php from "../../../assets/img/programming/php.webp";
import python from "../../../assets/img/programming/python.webp";
// import ruby from "../../../assets/img/programming/ruby.webp";
// import cplus from "../../../assets/img/programming/cplus.webp";
// import csharp from "../../../assets/img/programming/csharp.webp";
// import go from "../../../assets/img/programming/go.webp";

export const DataLanguage = [
  {
    title: "Javascript",
    path: "/programming/javascript",
    icon: javascript,
    cName: "icon",
    description:
      "JavaScript is a scripting or programming language that allows you to implement complex features on web pages — every time a web page does more than just sit there and display static information for you to look at — displaying timely content updates, interactive maps, animated 2D/3D graphics, scrolling video jukeboxes, etc.",
  },
  {
    title: "Typescript",
    path: "/programming/typescript",
    icon: typescript,
    cName: "icon",
    description:
      "TypeScript is a superset of JavaScript which primarily provides optional static typing, classes and interfaces. One of the big benefits is to enable IDEs to provide a richer environment for spotting common errors as you type the code.",
  },
  {
    title: "Java",
    path: "/programming/java",
    icon: java,
    cName: "icon",
    description:
      "Java is a write-once, run-anywhere programming language developed by Sun Microsystems. It is similar to C and C++ but a lot easier. You can combine Java with a lot of technologies like Spring, node js, Android, Hadoop, J2EE, etc",
  },
  {
    title: "Php",
    path: "/programming/php",
    icon: php,
    cName: "icon",
    description:
      "PHP is a server side scripting language. that is used to develop Static websites or Dynamic websites or Web applications. PHP stands for Hypertext Pre-processor, that earlier stood for Personal Home Pages. PHP scripts can only be interpreted on a server that has PHP installed.",
  },
  {
    title: "Python",
    path: "/programming/python",
    icon: python,
    cName: "icon",
    description:
      "Python is an interpreted, object-oriented, high-level programming language with dynamic semantics. Its high-level built in data structures, combined with dynamic typing and dynamic binding, make it very attractive for Rapid Application Development, as well as for use as a scripting or glue language to connect existing components together. ",
  },
  // {
  //   title: "Ruby",
  //   path: "/programming/ruby",
  //   icon: ruby,
  //   cName: "icon",
  // },
  // {
  //   title: "C++",
  //   path: "/programming/c-plus-plus",
  //   icon: cplus,
  //   cName: "icon",
  // },
  // {
  //   title: "C#",
  //   path: "/programming/c-sharp",
  //   icon: csharp,
  //   cName: "icon",
  // },
  // {
  //   title: "Go",
  //   path: "/programming/go",
  //   icon: go,
  //   cName: "icon",
  // },
];
